import { render, staticRenderFns } from "./LiabilityForm.vue?vue&type=template&id=8d3b4218&"
import script from "./LiabilityForm.vue?vue&type=script&lang=js&"
export * from "./LiabilityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports